import Div from '../Div';
import Paragraph from '../Paragraph';
import ChevronIcon from '@/components/Icons/Chevron';
import { memo } from 'react';
import Button from '../Button';
import { useAppConfigContext } from '@/context/AppContext';
import Tag from './Tag';
import { parseMediaFromCMS } from '@/utils/image';
import Image from '../Image';
import classNames from 'classnames';
import useScreen from '@/hooks/useScreen';
import dlv from 'dlv';
import { useRouter } from 'next/router';

const tagBgColor =
  'linear-gradient(90deg, #EBB00E 0%, #ECD780 100%), linear-gradient(127deg, #DDECFF 10.96%, rgba(204, 226, 255, 0.06) 94.81%)';

const DemoItem = ({ data, isPDP }: any) => {
  const { tagText, title, subTitle, cta, icon, isVideoDemo = false } = data || {};
  const { href, label, target = '_blank', onClick } = cta || {};
  const { isDesktop } = useScreen();
  const { state: appConfig, dispatch: appConfigDispatch } = useAppConfigContext();
  const { query } = useRouter();
  const handleButtonClick = () => {
    if (href === '#saleAssistAiva') {
      const aivaConfig = dlv(appConfig, 'config.saleAssist.aiva', null);
      if (
        window.saleassist &&
        aivaConfig &&
        Object.keys(aivaConfig).includes(query?.slug?.[0] as string)
      ) {
        window.saleassist?.mountWidget({
          id: aivaConfig[query?.slug?.[0] as string],
          form_factor: 'button',
        });
      }
      return;
    }
    appConfigDispatch.toggleSaleAssist(true);
  };

  return (
    <Button
      theme="link"
      href={!isVideoDemo ? href : undefined}
      id="saleassistButton"
      target={target}
      onClick={isVideoDemo ? handleButtonClick : onClick ? onClick : undefined}
      className="py-s5 !px-s5 border rounded-cs flex md:flex-col text-cm-primary !text-left hover:no-underline bg-white relative"
    >
      {tagText ? (
        <Tag
          className=" py-s2 px-s3 rounded-none !rounded-bl-cxs !rounded-tr-cs absolute top-0 right-0"
          style={{ background: tagBgColor }}
        >
          {tagText.toUpperCase()}
        </Tag>
      ) : null}
      <Div
        className={classNames('flex gap-s4 ', {
          '!mt-s3': tagText,
          'md:flex-col md:gap-s3 ': !isPDP,
        })}
      >
        <Image
          className="object-contain h-full aspect-square"
          width={isDesktop && !isPDP ? 32 : 24}
          height={isDesktop && !isPDP ? 32 : 24}
          src={parseMediaFromCMS(icon).src}
          alt=""
          loading="lazy"
        />
        <Div className="flex flex-col gap-s3">
          <Paragraph className="text-h-4 md:text-hd-3">{title}</Paragraph>
          <Paragraph className=" text-body-base md:text-body-lg">{subTitle}</Paragraph>
          <Div className="flex mt-s2 gap-s2 items-end text-cu-selected">
            <Paragraph className="text-button-small ">{label}</Paragraph>
            <ChevronIcon size={16} />
          </Div>
        </Div>
      </Div>
    </Button>
  );
};
export default memo(DemoItem);
